import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0dad24fe")

_pushScopeId("data-v-0dad24fe")
const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("label", {
  for: "kpi",
  class: "kn-material-input-label"
}, " Kpi *", -1)
const _hoisted_4 = { class: "p-grid p-mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-flex-column severity-container p-m-2"
}
const _hoisted_6 = { flex: "" }
const _hoisted_7 = {
  key: 0,
  class: "severity-box",
  style: {}
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Menu = _resolveComponent("Menu")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, {
    style: _ctx.alertDescriptor.styles.basicCard,
    class: "p-m-2"
  }, {
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_Dropdown, {
            id: "kpi",
            class: "kn-material-input",
            dataKey: "id",
            modelValue: _ctx.kpi,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.kpi = $event)),
            options: _ctx.kpiList,
            optionLabel: "name",
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmLoadSelectedKpi($event.value)))
          }, null, 8, ["modelValue", "options"]),
          _hoisted_3
        ])
      ]),
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withId(() => [
          _createVNode("span", null, _toDisplayString(_ctx.$t('kpi.alert.actionList')), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('kpi.alert.addAction'),
            class: "p-button-text p-button-rounded p-button-plain",
            disabled: _ctx.disableActionButton,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('showDialog'))),
            "data-test": "add-action-button"
          }, null, 8, ["label", "disabled"])
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alert.jsonOptions?.actions, (action, index) => {
          return (_openBlock(), _createBlock("div", {
            class: "p-m-2 p-shadow-2 action-box",
            key: index
          }, [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
              start: _withId(() => [
                _createVNode("span", null, _toDisplayString(action.data?.name), 1)
              ]),
              end: _withId(() => [
                _createVNode(_component_Button, {
                  class: "p-button-link p-button-sm",
                  style: _ctx.alertDescriptor.styles.menuButton,
                  icon: "fa fa-ellipsis-v",
                  onClick: ($event: any) => (_ctx.toggleMenu($event, { action, index })),
                  "aria-haspopup": "true",
                  "aria-controls": "overlay_menu",
                  "data-test": "menu-button"
                }, null, 8, ["style", "onClick"]),
                _createVNode(_component_Menu, {
                  ref: "menu",
                  model: _ctx.items,
                  popup: true,
                  "data-test": "menu"
                }, null, 8, ["model"])
              ]),
              _: 2
            }, 1024),
            action
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(action.thresholdData, (threshVal, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "p-d-inline-flex p-m-2",
                      key: index
                    }, [
                      _createVNode("div", {
                        class: "color-box",
                        style: { 'background-color': threshVal?.color }
                      }, null, 4),
                      _createVNode("span", _hoisted_6, _toDisplayString(threshVal?.label), 1),
                      (threshVal?.severityCd != undefined)
                        ? (_openBlock(), _createBlock("span", _hoisted_7, "(" + _toDisplayString(threshVal.severityCd) + ")", 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["style"]))
})